import { themeConfig } from '@kmx/mui-resources';
import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils/index.js';

const carmaxTheme = createTheme(
    deepmerge(themeConfig, {
        components: {
            MuiButtonBase: {
                defaultProps: {
                    // Re-enable the ripple for some reason...
                    disableRipple: false,
                },
            },
            MuiDialog: {
                styleOverrides: {
                    root: {},
                    paper: {
                        maxWidth: '568px',
                        width: '100%',
                        ['@media (max-width:450px)']: {
                            margin: '0px',
                        },
                    },
                    content: {
                        padding: '0px',
                    },
                    container: {
                        ['@media (max-width:450px)']: {
                            alignItems: 'end',
                        },
                    },
                },
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        padding: '0px',
                    },
                },
            },
        },
        zIndex: {
            modal: 2100000001,
            drawer: 2100000002,
            snackbar: 3100000000,
        },
        colorSchemes: { dark: false },
    })
);

export default carmaxTheme;
